import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['map', 'marker', 'overlay', 'popMap'];

  static values = {
    vendor: String,
    xcenter: String,
    ycenter: String,
    level: { type: Number, default: 7 },
    infowindows: []
  };

  connect() {
    if (this.vendorValue == 'KAKAO') {
      this.map = new kakao.maps.Map(this.mapTarget, {
        center: new kakao.maps.LatLng(this.ycenterValue, this.xcenterValue), //지도의 중심좌표
        level: this.levelValue, //지도의 확대 레벨
      });
  
      this.map.addControl(new kakao.maps.ZoomControl(), kakao.maps.ControlPosition.RIGHT);
      this.markerTargets.forEach(this.createMarker.bind(this));
      kakao.maps.event.addListener(this.map, 'click', () => {
        this.closeOverlay();
      });

    } else if (this.vendorValue == 'GOOGLE') {
      this.map = new google.maps.Map(this.mapTarget, {
        center: new google.maps.LatLng(this.ycenterValue, this.xcenterValue),
        zoom: 14,
      });
      this.markerTargets.forEach(this.createMarkerForGoogle.bind(this));

      this.map.addListener('click', () => {
        this.infowindowsValue.map(info => info.close());
      })
    }
  }

  // for kakao
  createMarker(marker) {
    const datesTerm =
      marker.firstElementChild.dataset.datesterm == null
        ? marker.firstElementChild.firstElementChild.dataset.datesterm
        : marker.firstElementChild.dataset.datesterm;

    const [posX, posY] = marker.dataset.coords.split(',');
    const imageSrc = datesTerm === 'true' ? '/images/icon-end-marker.png' : '/images/icon-marker.png'; //마커이미지의 주소입니다
    const imageSize = new kakao.maps.Size(32, 44); //마커이미지의 크기입니다
    const imageOption = { offset: new kakao.maps.Point(16, 43) }; //마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다

    const mk = new kakao.maps.Marker({
      map: this.map,
      position: new kakao.maps.LatLng(posY, posX),
      image: new kakao.maps.MarkerImage(imageSrc, imageSize, imageOption),
      clickable: true,
    });
    kakao.maps.event.addListener(mk, 'click', this.createOverlay.bind(this, marker, posY, posX));
  }

  createOverlay(marker, posY, posX) {
    if (marker.classList.contains('hidden')) marker.classList.remove('hidden');

    this.closeOverlay();

    this.overlay = new kakao.maps.CustomOverlay({
      map: this.map,
      position: new kakao.maps.LatLng(posY, posX),
      content: marker,
      yAnchor: 1.23,
      clickable: true,
    });
  }

  closeOverlay() {
    if (this.overlay != null) {
      this.overlay.setMap(null);
      this.overlay = null;
    }
  }

  // for google 
  createMarkerForGoogle(originMarkerDom) {
    const markerDom = originMarkerDom.cloneNode(true);
    // html에 임의로 그려둔 dom을 제거한다.
    originMarkerDom.remove();
    markerDom.classList.remove("hidden");

    const datesTerm =
      markerDom.firstElementChild.dataset.datesterm == null
        ? markerDom.firstElementChild.firstElementChild.dataset.datesterm
        : markerDom.firstElementChild.dataset.datesterm;

    const [posX, posY] = markerDom.dataset.coords.split(',');
    const imageSrc = datesTerm === 'true' ? '/images/icon-end-marker.png' : '/images/icon-marker.png'; //마커이미지의 주소입니다
  
    const marker = new google.maps.Marker({
      map: this.map,
      position: new google.maps.LatLng(posY, posX),
      icon : {
        url: imageSrc, 
        scaledSize: new google.maps.Size(32, 44)
      }
    });

    const infowindow = new google.maps.InfoWindow({
      content: markerDom,
    });
    console.log(infowindow);
    this.infowindowsValue.push(infowindow)

    marker.addListener("click", function(infowindows) {
      return function () {
        // 이전에 열여있던 인포윈도우 닫기
        infowindows.map(info => info.close());
        const map = infowindow.getMap()
        const isClose = !(map !== null && typeof map !== "undefined");
        if (isClose) {
          infowindow.open({anchor: marker, map});
        }
      }
    }(this.infowindowsValue));
  }
}
